module.exports = __webpack_public_path__ + "img/file_pdf.f975ef73.svg";